import { useCallback } from 'react';
import { useSearchParams } from '@direct-frontend/modules-router';
import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { constructorProductLoggingEvents } from '../lib/constructorProductLoggingEvents';
import { CONSTRUCTOR_LEFT_BAR_TABS } from '../model/constants';
import { type ConstructorLeftBarTab } from '../model/slices/types';

export const isConstructorLeftBarMode = (mode: string): mode is ConstructorLeftBarTab =>
    Boolean(CONSTRUCTOR_LEFT_BAR_TABS.find((item) => item === mode));

export const useChangeConstructorLeftBar = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onTabChange = useCallback(
        (tabValue: string) => {
            const tab = CONSTRUCTOR_LEFT_BAR_TABS.find((item) => item === tabValue);

            if (tab) {
                logEventString(constructorProductLoggingEvents.LeftBar.SettingsTab, tab);

                searchParams.set('tab', tab);
                setSearchParams(searchParams, { replace: true });
            }
        },
        [searchParams, setSearchParams]
    );

    return onTabChange;
};
